module.exports = __webpack_public_path__ + "assets/1d03d75fc3a060a91b7b2fd59c7451f5.mp3";